import React from "react";
import { useNavigate } from "react-router-dom";
import "./SVPProgram.css";

const SVPProgram = () => {
  const navigate = useNavigate();

  return (
    <div className="svp-container">
      <h2 className="svp-title">Saudi Skill Verification Program (SVP)</h2>

      <p className="svp-description">
        <strong>First RDTC in India</strong> to receive SVP accreditation for driving trades.
        Conducted assessments in <strong>5 driving categories</strong> (Mini Truck, Car, Truck, Taxi, Bus).
        <strong> 3050+ Indian drivers</strong> certified and placed in Saudi Arabia.
        Till date <strong>(Jan–Sept 2025)</strong>, a total of
        <strong> 2,516 candidates</strong> have been tested under the SVP at RDTC Ajmer.
      </p>

      <p className="svp-description">
        <strong>Trade Expansion (2025):</strong> RDTC Ajmer has further broadened its role by adding
        <strong> Auto Electrician</strong> and <strong>Auto Mechanic</strong> trades, enabling
        Indian workers to access wider overseas employment opportunities.
      </p>

      {/* ✅ Removed Chart Grid */}
      <div className="svp-text-section">
        <p>
          NSDC signed an MoU in 2019 with TakaMol Holding, a Semi–Government Agency under the Ministry of
          Labor & Social Development, Kingdom of Saudi Arabia for Skill Verification Program in India.
        </p>
        <p>
          Under the MoU, a network of Assessment Centres (Trade Test Centres)/Skill Verification Centres
          across India has been established to deliver assessments of benchmarked qualifications to
          potential migrant workers.
        </p>
      </div>

      <div className="button-container">
        <button className="back-button" onClick={() => navigate("/")}>
          ⬅ Back to Home
        </button>
      </div>
    </div>
  );
};

export default SVPProgram;
